<tidy-card>
  <div style="display: flex; align-items: flex-start; gap: 16px;">
    <img
      src="assets/img/tidy-wifi-noise-sensor.png"
      alt="TIDY Sensor"
      style="width: 60px; height: 60px; border-radius: 8px; object-fit: contain; flex-shrink: 0;" />
    <div>
      <tidy-row>
        <tidy-text [header]="'TIDY Wi-Fi Router & Noise Sensor'" />
      </tidy-row>
      <tidy-row>
        <tidy-text [body]="'This package is required for noise monitoring and Wi-Fi marketing. $250 per sensor, including tax and shipping.'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [actionBody]="'Order Sensor'"
          (action)="onOrderClick()"
          class="link" />
        &nbsp;
        <tidy-text
          [actionBody]="'Learn More'"
          (action)="learnMoreClick.emit()"
          class="link" />
      </tidy-row>
    </div>
  </div>
</tidy-card>
